











































































import Vue, { VueConstructor } from 'vue'
import { Page } from '@/interfaces/Page'
import ColorPicker from '@/components/picker/ColorPicker.vue'
import ColorMagnifier from '@/components/picker/ColorMagnifier.vue'
import HistoryControl from '@/components/HistoryControl.vue'
import HelpModal from '@/components/HelpModal.vue'
import LoadingModal from '@/components/LoadingModal.vue'
import IllustrationLoading from '@/components/IllustrationLoading.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'
import { CustomPageMeta } from '@/interfaces/CustomPageMeta'
import { AsyncComponentFactory } from 'vue/types/options'

interface Options {
  $route: {
    params: {
      id: string
    }
  }
  $refs: {
    page: {
      reset(): void
      randomize(): void
      $el: HTMLElement
    }
    historyControl: {
      onUndo(): void
      onRedo(): void
    }
  }
}

function makeAsyncComponent(id: string): AsyncComponentFactory {
  return () => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    component: import('@/components/illustrations/' + id + '.vue'),
    loading: IllustrationLoading,
  })
}

interface Data {
  selectedColor?: string
  hasUndo: boolean
  hasRedo: boolean
  pickerX: number
  pickerY: number
  pickerActive: boolean
  /** If the color fill mode is set to true, fills a cell with the current color. False puts the page into picker mode */
  fillMode: boolean
  /** If the help modal should be open */
  helpOpen: boolean
  /** If we are loading the screen */
  loading: boolean
  /** If the "are you sure you want to go back" confirmation modal should be displayed. */
  confirmBack: boolean
}
export default (Vue as VueConstructor<Vue & Options>).extend({
  components: {
    ColorPicker,
    HistoryControl,
    ColorMagnifier,
    HelpModal,
    LoadingModal,
    ConfirmModal,
  },
  data(): Data {
    return {
      selectedColor: '#FF0000',
      hasUndo: false,
      hasRedo: false,
      pickerX: 0,
      pickerY: 0,
      pickerActive: false,
      fillMode: true,
      helpOpen: window.sessionStorage.getItem('help-viewed') != 'true',
      loading: false,
      confirmBack: false,
    }
  },
  computed: {
    pages(): Page[] {
      return this.$store.state.page.all
    },
    page(): Page {
      return this.pages.find(o => o.id == this.$route.params.id) as Page
    },
    illustration(): AsyncComponentFactory {
      return makeAsyncComponent(this.page.component)
    },
    pageID(): string {
      const pageId = this.$route.params.id
      return pageId.charAt(0).toUpperCase() + pageId.slice(1)
    },
    // illustration(): () => Promise<VueConstructor> {
    //   return () =>
    //     import("@/components/illustrations/" + this.page.component + ".vue");
    // }
  },
  methods: {
    async onSave() {
      this.loading = true
      this.$refs.page.reset()
      await this.$nextTick()
      try {
        const token = await this.$recaptcha({ action: 'post_image' })
        const record: CustomPageMeta = await this.$store.dispatch('page/postPage', {
          id: this.page.id,
          img: this.$refs.page.$el.outerHTML,
          token,
        })
        this.$router.push('/s/' + record.uid)
        // this.$router.push("/fake-share/" + this.$route.params.id);
      } catch (err) {
        console.log(err)
        this.$router.push('/error')
      }
      // this.loading = false;
    },
    onPick(color: string) {
      this.selectedColor = color
    },
    onUndo() {
      this.$refs.historyControl.onUndo()
    },
    onRedo() {
      this.$refs.historyControl.onRedo()
    },
    onUndoStateChange(length: number) {
      this.hasUndo = length > 0
    },
    onRedoStateChange(length: number) {
      this.hasRedo = length > 0
    },
    onPicker(phase: string, { x, y }: { x: number; y: number }) {
      if (phase == 'active') {
        this.pickerActive = true
      } else if (phase == 'inactive') {
        this.pickerActive = false
      }
      this.pickerX = x
      this.pickerY = y
    },
    onClose(mode: 'help' | 'back'): void {
      if (mode == 'help') {
        this.helpOpen = false
        window.sessionStorage.setItem('help-viewed', 'true')
      } else {
        this.confirmBack = false
      }
    },
    onPrint(): void {
      window.print()
    },
  },
})
